export const hyb_friday:string = 'GoTT@ R_N B3fOr3 '
